import { render, staticRenderFns } from "./ViewSalesDeliveryPage.vue?vue&type=template&id=3297f4d4"
import script from "./ViewSalesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./ViewSalesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports